import { ShieldCheck, Clock, Award, Users } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaSection } from "@/components/CtaSection";
import { COMPANY } from "@/data/company";
import { breadcrumbSchema, localBusinessSchema } from "@/lib/schema";

export default function SobrePage() {
  const crumbs = [
    { name: "Início", url: "/" },
    { name: "Sobre", url: "/sobre" },
  ];
  return (
    <main className="max-w-7xl mx-auto px-4 md:px-8" data-testid="sobre-page">
      <Seo
        title="Sobre a Desentupidora em Guarulhos | Empresa Especializada 24h"
        description="Conheça a Desentupidora em Guarulhos: empresa especializada em desentupimento de emergência 24h, com equipes próprias, garantia formal e nota fiscal. CNPJ 82.876.922/0001-21."
        path="/sobre"
        jsonLd={[breadcrumbSchema(crumbs), localBusinessSchema()]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center py-6">
        <div>
          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-brand-dark uppercase tracking-tight leading-tight">
            Sobre a <span className="text-brand-red">Desentupidora em Guarulhos</span>
          </h1>
          <div className="mt-5 space-y-4 text-gray-700 text-sm md:text-base leading-relaxed">
            <p>
              A <strong>{COMPANY.razaoSocial}</strong> (CNPJ {COMPANY.cnpj}) é uma empresa especializada em atendimento de emergência em desentupimento e limpeza técnica, com sede na {COMPANY.endereco}, em Guarulhos — SP.
            </p>
            <p>
              Nossa especialidade são as soluções premium em desentupimento para mansões, coberturas, condomínios de alto padrão, restaurantes, escritórios corporativos e comércios finos, sempre com discrição, agilidade e foco em prevenção.
            </p>
            <p>
              Operamos com equipes próprias, uniformizadas e treinadas, distribuídas estrategicamente pelos 10 maiores bairros de Guarulhos para garantir chegada média de 15 a 40 minutos em qualquer emergência, 24 horas por dia, 7 dias por semana, inclusive feriados.
            </p>
          </div>
        </div>
        <img src="/images/equipe-desentupidora-guarulhos.webp" alt="Equipe da Desentupidora em Guarulhos com caminhões e equipamentos profissionais" width="1264" height="848" className="rounded-2xl shadow-lg w-full" />
      </section>

      <section className="grid grid-cols-2 lg:grid-cols-4 gap-5 py-10" data-testid="sobre-stats">
        {[
          { icon: Clock, num: "24h", label: "Plantão todos os dias" },
          { icon: Users, num: "10+", label: "Bairros com equipes fixas" },
          { icon: Award, num: "4.9★", label: "Avaliação média dos clientes" },
          { icon: ShieldCheck, num: "100%", label: "Serviços com garantia e NF" },
        ].map((s, i) => (
          <div key={i} className="bg-brand-light rounded-xl p-6 text-center">
            <s.icon size={26} className="text-brand-red mx-auto mb-3" />
            <p className="font-heading font-black text-2xl md:text-3xl text-brand-dark">{s.num}</p>
            <p className="text-xs md:text-sm text-gray-600 mt-1">{s.label}</p>
          </div>
        ))}
      </section>

      <CtaSection titulo="Conheça nosso atendimento na prática" texto="Chame agora no WhatsApp e comprove: resposta em segundos, orçamento fechado e chegada em minutos." />
    </main>
  );
}
